import axios from 'axios';

const subscribeToBuyerShowings = async (dashboardId: string) => {
  const config = {
    url: `/external/dash/${dashboardId}/almanac/buyer_subscription`,
    method: 'post' as const,
  };

  await axios.request<{ id: string }>(config);
};

export default subscribeToBuyerShowings;
